__turbopack_context__.v({
  "amount": "_2ahnla_amount",
  "canvas": "_2ahnla_canvas",
  "card": "_2ahnla_card",
  "cut": "_2ahnla_cut",
  "l1": "_2ahnla_l1",
  "l2": "_2ahnla_l2",
  "label": "_2ahnla_label",
  "logo": "_2ahnla_logo",
});
